import { MAIN_COMPANY } from "../../MainCompany.js";

export const APP_COMPANY = Object.freeze({
  ...MAIN_COMPANY,
  COMPANY_NAME: MAIN_COMPANY.COMPANY_NAME || MAIN_COMPANY.APP_NAME || "",
  COMPANY_LOCALE: MAIN_COMPANY.APP_LOCALE || "es_AR",
});
